module.exports = __webpack_public_path__ + "static/img/news0.2a9e356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/news0.jpg
// module id = HbSN
// module chunks = 0